var $34cbe20a71cdcbd0$exports = {};
$34cbe20a71cdcbd0$exports = {
    "loading": `Ladataan\u{2026}`,
    "placeholder": `Valitse\u{2026}`
};


export {$34cbe20a71cdcbd0$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
